export default __webpack_public_path__ + "static/media/lock.f52f3995.svg";